import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_boarding-school-fit/artifacts/5kmsljm9_ESA%20Final%20Logo.png";

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-[#FDFCF8]">
      {/* Header */}
      <header className="bg-[#FDFCF8] border-b border-[#E2E8F0] py-4">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl flex items-center justify-between">
          <Link to="/">
            <img src={LOGO_URL} alt="Elite School Advisory" className="h-12 w-auto" />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-[#2B4C7E] hover:text-[#C9A227] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 md:px-8 max-w-4xl py-16">
        <h1
          className="text-3xl md:text-4xl font-semibold text-[#1A202C] mb-8"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Refund Policy
        </h1>

        <div className="prose prose-lg max-w-none text-[#4A5568]">
          <p className="text-sm text-[#4A5568] mb-8">
            Last updated: December 2025
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              1. Overview
            </h2>
            <p>
              At Elite School Advisory, operated by Mindways Consulting Pvt Ltd, we are committed to providing high-quality advisory services. This Refund Policy outlines the terms and conditions under which refunds may be considered.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              2. Nature of Services
            </h2>
            <p>
              Our services are professional advisory and consulting services. As such, refunds are handled differently from product returns. The time, expertise, and resources invested in providing our services cannot be recovered once rendered.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              3. Refund Eligibility
            </h2>
            <p className="mb-4">Refunds may be considered in the following circumstances:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Service Not Commenced:</strong> If you cancel before any services have been rendered, a full refund minus administrative charges may be provided.</li>
              <li><strong>Partial Service:</strong> If you cancel after services have commenced, a pro-rata refund may be considered based on services not yet rendered.</li>
              <li><strong>Service Quality Issues:</strong> If you are dissatisfied with our services, please raise your concerns with us directly. We will work to resolve issues and may offer partial refunds or additional services at our discretion.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              4. Non-Refundable Items
            </h2>
            <p className="mb-4">The following are not eligible for refunds:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Initial consultation and diagnostic fees</li>
              <li>Services that have been fully rendered</li>
              <li>Third-party fees (test registration, school application fees, etc.)</li>
              <li>Administrative and processing charges</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              5. Admission Outcomes
            </h2>
            <p>
              Please note that refunds are not provided based on admission outcomes. Our services are advisory in nature, and admission decisions are made solely by the schools. We do not guarantee admission to any institution, and fees are charged for our advisory services, not for admission results.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              6. Refund Process
            </h2>
            <p className="mb-4">To request a refund:</p>
            <ol className="list-decimal pl-6 space-y-2">
              <li>Contact us in writing at eliteschooladvisory@gmail.com</li>
              <li>Clearly state the reason for your refund request</li>
              <li>Provide relevant documentation if applicable</li>
              <li>Allow up to 15 business days for review and response</li>
              <li>Approved refunds will be processed within 30 business days</li>
            </ol>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              7. Dispute Resolution
            </h2>
            <p>
              If you are not satisfied with our refund decision, we encourage you to discuss the matter with our team. We are committed to fair resolution and will consider all circumstances on a case-by-case basis.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              8. Contact Us
            </h2>
            <p>
              For refund enquiries or concerns, please contact us at:
            </p>
            <p className="mt-4">
              <strong>Elite School Advisory</strong><br />
              Operated by Mindways Consulting Pvt Ltd<br />
              New Delhi, India<br />
              Email: eliteschooladvisory@gmail.com<br />
              Phone: +91 98180 65496
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default RefundPolicy;
